import pb from '../lib/pocketbase';

export type PageViewRecord = {
  page: string;
  timestamp: string;
  user_agent: string;
};

export async function trackPageView(page?: string): Promise<void> {
  if (typeof window === 'undefined') {
    return;
  }

  if (pb.authStore.isValid) {
    return;
  }

  try {
    const resolvedPage = page ?? `${window.location.pathname}${window.location.search}`;

    const data: PageViewRecord = {
      page: resolvedPage,
      timestamp: new Date().toISOString(),
      user_agent: navigator.userAgent
    };

    await pb.collection('page_views').create(data);
  } catch (error) {
    console.error('Page view tracking failed:', error);
  }
}

export async function getRecentPageViews(limit: number = 200) {
  try {
    const result = await pb.collection('page_views').getList(1, limit, {
      sort: '-created'
    });

    return result.items as unknown as Array<
      {
        id: string;
        created: string;
        updated: string;
      } & PageViewRecord
    >;
  } catch (error) {
    console.error('Failed to load page views:', error);
    return [];
  }
}
